import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  TipLiteModel,
  TipCreateInput,
  TipDeleteInput,
  TipUpdateInput,
} from './model';

export function useCreateOtherExpenses(
  options?: UseMutationOptions<
    ApiResult<TipLiteModel>,
    ApiError,
    TipCreateInput
  >,
): UseMutationResult<ApiResult<TipLiteModel>, ApiError, TipCreateInput> {
  return useMutation<ApiResult<TipLiteModel>, ApiError, TipCreateInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `sales/${body.saleId}/add-tips`,
        method: 'POST',
        classType: TipLiteModel,
        body: body.body,
      });
    },
    options,
  );
}

export function useUpdateTip(
  options?: UseMutationOptions<
    ApiResult<TipLiteModel>,
    ApiError,
    TipUpdateInput
  >,
): UseMutationResult<ApiResult<TipLiteModel>, ApiError, TipUpdateInput> {
  return useMutation<ApiResult<TipLiteModel>, ApiError, TipUpdateInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `sales/update-tip/${body.tipId}`,
        method: 'PUT',
        classType: TipLiteModel,
        body: body.body,
      });
    },
    options,
  );
}

export function useVoidTip(
  options?: UseMutationOptions<{ message: string }, ApiError, TipDeleteInput>,
): UseMutationResult<{ message: string }, ApiError, TipDeleteInput> {
  return useMutation<{ message: string }, ApiError, TipDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `sales/void-tip/${body.tipId}`,
        method: 'PATCH',
      });
    },
    options,
  );
}
